/**
 * Miss row for Verbs — the shared row without the gender tint, since a verb has
 * no article to colour.
 */
import { MissRowFrame, UserAnswer } from '@/components/practice/SharedMissRow';
import type { VerbPayload } from '@/core/types';

import type { MissRowProps } from '../types';

export function MissRow({ card, user_answer }: MissRowProps<VerbPayload>) {
  const answer = (card.translations.en ?? []).join(', ');
  return (
    <MissRowFrame>
      <div className="flex flex-wrap items-baseline justify-between gap-x-4 gap-y-0.5">
        <span className="font-display text-base font-semibold">
          {card.payload.reflexive && <span className="text-muted-foreground">sich </span>}
          {card.de}
        </span>
        <span className="text-base">{answer}</span>
      </div>
      <UserAnswer user_answer={user_answer} verb="wrote" />
    </MissRowFrame>
  );
}
